import React from 'react';
import Image from "next/image";
import Snappay from "@/public/icons/snappay.svg";
import { SingleProductEnum } from "@/constants/commerce-enum";

interface IProps {
    data: any;
}

const SnappPayMobile: React.FC<IProps> = ({ data }) => {
    if (!data) return null;
    return (
        <div className='w-full flex gap-2 items-center lg:mt-0 mt-10'>
            <Image src={Snappay} alt={"snappay-icon"} width={45} height={45} />
            <div className='w-auto flex flex-wrap'>
                <div className="w-full text-sm font-medium">
                    {SingleProductEnum.SnapPayInstallmentPayment}
                </div>
                <div className="w-full flex text-xs mt-2 font-medium text-gray-400">
                    {SingleProductEnum.monthlyInstallment}
                    <span className="px-0.5">
                        {(Math.round(data / 4))?.toLocaleString("fa")}
                    </span>
                    {SingleProductEnum.Toman} ({SingleProductEnum.withoutFee})
                </div>
            </div>
        </div>
    );
};

export default React.memo(SnappPayMobile);